/* eslint-disable */
define(function (Viewport) {
    /**
    * @title    - Cta Module
    * @desc     - Overall code for Cta module
    * @param    - none
    * @return   - object with public functions and/or variables
    */
    FormLocations = (function() {

        var init = function() {

          if(document.getElementsByClassName('gform_wrapper').length > 0) {

          jQuery(document).ready(function($) {

            $.fn.filterSelect = function(citySelect) {
              return this.each(function() {
                var select = this;
                var options = [];
                $(select).find('option').each(function() {
                  options.push({
                    value: $(this).val(),
                    text: $(this).text(),
                  });
                });
                $(select).data('options', options);

                $(citySelect).bind('change', function () {

                  var placeholder = $(select).find('.gf_placeholder').detach();
                  var options = $(select).empty().data('options');
                  var search = $(citySelect).find('option:selected').val();
                  var regex = new RegExp('^' + search, 'i');

                  placeholder.appendTo( select );
                  $.each(options, function(i) {
                    var option = options[i];
                    if (option.value.match(regex) !== null) {
                      $(select).append(
                        $('<option>').text(option.text).val(option.value)
                      );
                    }
                  });
                  $(select).find('.gf_placeholder').attr('selected',true).change();
                });

              });
            };

            $(function () {
              //$('.populate_citys .ginput_container_select select').change();
            });

            $('.populate_locations .ginput_container_select select').filterSelect($('.populate_citys .ginput_container_select select'));

            function showLocationInfo() {
              var locationSelect = $('.populate_locations .ginput_container_select select');
              $('.location-info-holder').removeClass('currentLocation').hide();
              var selectedVal = locationSelect.find('option:selected').val();
              if( selectedVal ) {
                var selectedLocation = '.'+selectedVal;
                $(selectedLocation).addClass('currentLocation').show();
              }
            }
            showLocationInfo();

            $('.populate_locations .ginput_container_select select').bind('change', function () {
              showLocationInfo();
              $('.beginTime').setRadioTime('reset');
              $('.endTime').setRadioTime('reset');
            });

            $.fn.setRadioTime = function(day) {

              var currentDay = $('.currentLocation').find('[data-day=\'' + day + '\']'),
                  beginRadio = $(this).find('.gfield_radio');

              if( day == 'reset' ) {
                beginRadio.find('input').attr('disabled', 'disabled');
                beginRadio.find('li').eq(0).find('label').text('Kies datum');
                beginRadio.find('li').eq(0).find('input').val('Kies datum');
                beginRadio.find('li').eq(1).find('label').text('Kies datum');
                beginRadio.find('li').eq(1).find('input').val('Kies datum');
              } else if( currentDay.data('closed') == true ) {
                beginRadio.find('input').attr('disabled', 'disabled');
                beginRadio.find('li').eq(0).find('label').text('gesloten');
                beginRadio.find('li').eq(0).find('input').val('gesloten');
                beginRadio.find('li').eq(1).find('label').text('gesloten');
                beginRadio.find('li').eq(1).find('input').val('gesloten');
              } else {
                beginRadio.find('input').removeAttr('disabled');
                if( $(this).hasClass('beginTime') ) {
                  var dayBeginTime = currentDay.data('starttime'),
                      dayBeginTimeLabel = dayBeginTime+' uur',
                      dayEndTime = currentDay.data('endtime'),
                      dayEndTimeLabel = dayEndTime+' uur';
                } else {
                  var dayBeginTime = currentDay.data('starttime2'),
                      dayBeginTimeLabel = dayBeginTime+' uur',
                      dayEndTime = currentDay.data('endtime2'),
                      dayEndTimeLabel = dayEndTime+' uur';
                }
                beginRadio.find('li').eq(0).find('label').text(dayBeginTimeLabel);
                beginRadio.find('li').eq(0).find('input').val(dayBeginTime);
                beginRadio.find('li').eq(1).find('label').text(dayEndTimeLabel);
                beginRadio.find('li').eq(1).find('input').val(dayEndTime);
              }

            };

            if(document.getElementsByClassName('begindate').length > 0) {
              var beginDateLoad = jQuery('.begindate .datepicker').datepicker('getDate');
              if(beginDateLoad) {
                dayNrLoad = beginDateLoad.getUTCDay();
                jQuery('.beginTime').setRadioTime(dayNrLoad);
              }
              var endDateLoad = jQuery('.enddate .datepicker').datepicker('getDate');
              if(endDateLoad) {
                dayNrLoad = endDateLoad.getUTCDay();
                jQuery('.endTime').setRadioTime(dayNrLoad);
              }
            }

          });

        }

      };

// return public functions and/or variables to use in other modules
return {
    init: init,
};



    }());

  FormLocations.init();
});


// WEBPACK FOOTER //
// ./scripts/legacy/modules/form-locations.js